var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.5,
    height: 46.5,
    viewBox: "0 0 46.5 46.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_link-2",
    "data-name": "vuesax/bulk/link-2",
    transform: "translate(-108 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link-2",
    transform: "translate(108 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.409,3.735a12.756,12.756,0,0,1-5.987,21.409,12.717,12.717,0,0,0-3.371-12.051A12.717,12.717,0,0,0,0,9.721,12.756,12.756,0,0,1,21.409,3.735Z",
    transform: "translate(15.539 5.817)",
    fill: "#fd4082",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M21.753,21.765a1.411,1.411,0,0,1-2-2,9.919,9.919,0,1,0-14.028,0,1.411,1.411,0,0,1-2,2,12.755,12.755,0,1,1,18.019,0Z",
    transform: "translate(15.195 5.825)",
    fill: "#fd4082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M21.773,3.739A12.752,12.752,0,1,1,9.721.368,12.717,12.717,0,0,1,21.773,3.739Z",
    transform: "translate(5.817 15.171)",
    fill: "#fd4082",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M3.737.421a1.392,1.392,0,0,1,2,0,1.392,1.392,0,0,1,0,2,9.919,9.919,0,1,0,14.027,0,1.392,1.392,0,0,1,0-2,1.392,1.392,0,0,1,2,0,12.755,12.755,0,1,1-18.019,0Z",
    transform: "translate(5.815 18.489)",
    fill: "#fd4082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H46.5V46.5H0Z",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkColored);
export default __webpack_public_path__ + "static/media/link-colored.293109e905509406d577b8bd964bd8f1.svg";
export { ForwardRef as ReactComponent };